export default {
	"daa1353d65dafad624b1a415c2b3d5ff": "确认要删除该地址吗",
	"9f2d441c5f6016b94332c4e1024c4a32": "取消",
	"73b7dcaaff05d3974ca1b8bf11cf873e": "确认"
}
